import React, {useMemo} from "react";
import {StatusBadge, StatusBadgeProps} from "~/apps/core/ui/StatusBadge";
import {getAdmissionStatusColor, humanizeAdmissionStatus} from "~/apps/packages/passes/utils";
import {Admission} from "~/queries";


export type AdmissionStatusBadgeProps = Omit<StatusBadgeProps<Admission["status"]>, "badgeColor">


export const AdmissionStatusBadge = (props: AdmissionStatusBadgeProps) => {
    const {children, ...other} = props;
    const status = useMemo(() => humanizeAdmissionStatus(children), [children]);
    const color = useMemo(() => getAdmissionStatusColor(children), [children])

    return (
        <StatusBadge {...other} badgeColor={color} outlined={false}>
            {status}
        </StatusBadge>
    )
}